import { render, staticRenderFns } from "./FloatSelector.vue?vue&type=template&id=23451c20"
import script from "./FloatSelector.vue?vue&type=script&lang=js"
export * from "./FloatSelector.vue?vue&type=script&lang=js"
import style0 from "./FloatSelector.vue?vue&type=style&index=0&id=23451c20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports